import React, { useEffect, useMemo, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { listProducts, unloadProducts } from '../../../../modules/productModule/products';
import MasProductListBox from '../../../../components/common/form/modal/MasProductListBox';
import MasProductList from '../../../../components/common/form/modal/MasProductList';

const MasProductListContainer = ({ handleClose, selectedProduct }) => {
    const dispatch = useDispatch();

    const { products, error, loading } = useSelector(
        ({ productModule, loading }) => ({
            products: productModule.products.products,
            error: productModule.products.error,
            loading: loading['product/LIST_PRODUCTS'],
        }),
    );

    const initialValues = {
        searchKeyword: 'productNm',
        searchWords: '',
      };
    
    
      const validationSchema = yup.object({
        searchKeyword: yup.string('').nullable(),
        searchWords: yup.string('').trim().nullable(),
      });
    
      const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
          setSubmitting(true);
    
          let searchData = {
            [values.searchKeyword]: values.searchWords,
          };
    
    
          setTimeout(() => {
            // alert(JSON.stringify(values, null, 2));
            dispatch(listProducts(searchData));
            // formik.resetForm();
            setSubmitting(false);
          }, 1000);
        },
      });

    useEffect(() => {
        dispatch(listProducts());

        return () => {
            dispatch(unloadProducts());
        };
    }, []);



    const apiRef = useGridApiRef();

    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
            },
            {
                field: 'productUuid',
                headerName: 'productUuid',
                hide: true,
                type: 'string',
                editable: false,
            },
            {
                field: 'partnerUuid',
                headerName: '제조사ID',
                hide: true,
            },
            {
                field: 'productLine',
                headerName: '제품군',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },
            {
                field: 'modelNm',
                headerName: '모델명',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },
            {
                field: 'productNm',
                headerName: '제품명',
                minWidth: 300,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',

            },
            {
                field: 'partnerNm',
                headerName: '제조사',
                minWidth: 200,
                flex: 1,
                type: 'string',
                editable: false,
                align: 'left',
                headerAlign: 'center',
            },
            {
                field: 'price',
                headerName: '가격',
                minWidth: 200,
                flex: 1,
                type: 'number',
                valueFormatter: (value) => {
                    const valueFormatted = Number(value).toLocaleString('ko-KR');
                    return `₩ ${valueFormatted}`;
                },
                editable: false,
                align: 'right',
                headerAlign: 'center',
            },
            {
                field: 'category',
                headerName: '분류',
                minWidth: 200,
                flex: 1,
                description: '',
                editable: false,
                align: 'center',
                headerAlign: 'center',
            },

            {
                field: 'useYn',
                headerName: '사용유무',
                minWidth: 80,
                flex: 1,
                type: 'boolean',
                editable: false,
                align: 'center',
                headerAlign: 'center',
            },
        ],
        [],
    );

    const handleRowClick = (data) => {
       // console.log(data.row, 'row');
        selectedProduct(data.row);
        formik.resetForm();
        dispatch(listProducts());
        handleClose();
    }

    


    return (
        <div>
            <MasProductListBox formik={formik}/>
            <MasProductList
                apiRef={apiRef}
                columns={columns}
                rows={products}
                error={error}
                loading={loading}
                handleRowClick={handleRowClick}
                
        columnVisibilityModel={{
            id: false,
            productUuid: false,
            partnerUuid: false,
          }}
            />
        </div>
    )
}

export default MasProductListContainer